<template>
  <div
    class="relative rounded-md overflow-hidden shadow-lg border border-gray-200 bg-white"
  >
    <NuxtPicture
      :src="props.image.src"
      :alt="props.image.alt"
      :title="props.image.title"
      sizes="100vw mobile:640px laptop:1920px"
      loading="lazy"
      class="absolute inset-0"
    />

    <div
      class="relative z-10 mx-8 my-6 text-left grid gap-x-8 gap-y-4
        grid-cols-1 grid-rows-[auto_auto_auto_1fr]
        laptop:grid-cols-[2fr_3fr] laptop:grid-rows-[auto_auto_1fr]"
    >
      <NuxtPicture
        :src="props.float.src"
        :alt="props.float.alt || ''"
        sizes="100vw mobile:640px"
        loading="lazy"
        class="laptop:row-span-3"
      />

      <h2
        class="text-white"
      >
        {{ props.heading }}
      </h2>

      <p
        class="text-white"
      >
        {{ props.paragraph }}
      </p>

      <div class="flex flex-row gap-2 justify-start">
        <NuxtLink
          :to="props.to"
          class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
        text-center rounded py-2 px-4 mt-auto font-semibold"
        >
          {{ t('jc.component.gameCard.link.label') }}
        </NuxtLink>
        <NuxtLink
          v-if="props.leaderboard"
          :to="props.leaderboard"
          class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
        text-center rounded py-2 px-4 mt-auto font-semibold"
        >
          {{ t('jc.component.gameCard.leaderboard.label') }}
        </NuxtLink>
        <NuxtLink
          v-if="props.guide"
          :to="props.guide"
          class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
        text-center rounded py-2 px-4 mt-auto font-semibold"
        >
          {{ t('jc.component.gameCard.guide.label') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { Image } from '~/utils/types'

const { t } = useI18n()

const props = defineProps<{
  // resources
  image: Image
  float: Image
  // text
  heading: string
  paragraph: string
  // buttons
  to: RouteLocationRaw
  leaderboard?: RouteLocationRaw
  guide?: RouteLocationRaw
}>()
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply w-full h-full object-cover object-center
}
</style>
